<template lang="pug">
  app-dialog(v-model="$_show" header="Удалить документ базы знаний?")

    div.center Вы хотите удалить документ {{ delDoc.clause }} из базы знаний
    
      div.mt-5
        v-btn.mr-3(@click="delKBDoc") Удалить    
        v-btn(@click="$_show = !$_show") Отмена

</template>

<script>
import { mapActions } from 'vuex'
import { AppDialogToggable } from "@/components"

export default {
  mixins: [AppDialogToggable],
  computed: {
    
  },

  methods: {
    $_beforeShow (doc) {
      this.delDoc = doc
    },
    delKBDoc(){
      this.delKnowledgeDoc(this.delDoc)
      this.$_show = !this.$_show
    },
    ...mapActions('knowledgeBase', ['delKnowledgeDoc']),
  },

  data () {
    return {
      delDoc:{}
    }
  },
}
</script>

<style lang="scss" scoped>
  .center {text-align:center;}
</style>